class ICoreMiniSearchWidget {
    options = {};
    triggerButton = null;
    templateElement = null;

    eventHandler = {};
    closeButton = null;

    constructor(element, options = {}) {
        this.triggerButton = element;
        this.options = options;
        this.templateElement = document.getElementById(this.triggerButton.dataset.temp);
        this.closeButton = this.templateElement.querySelector('.icore-mini-widget-search-close');

        this.eventHandler = {
            escapeKey: this.onEscapeKey.bind(this),
            closeButtonClick: this.onCloseButtonClick.bind(this),
        }

        this.#initEvents();
    }

    #initEvents() {
        this.closeButton.addEventListener('click', this.eventHandler.closeButtonClick);
        document.addEventListener('keydown', this.eventHandler.escapeKey);
    }

    onCloseButtonClick(evt) {
        evt.preventDefault();
        this.close();
    }

    onEscapeKey(evt) {
        if (evt.key === 'Escape') {
            this.close();
        }
    }

    open() {
        window.$iCore.actions.destroyLenis();
        this.templateElement.classList.add('is--active');
        document.body.classList.add('icore-mini-search-opened');
    }

    close() {
        this.templateElement.classList.remove('is--active');
        document.body.classList.remove('icore-mini-search-opened');
        window.$iCore.actions.initializeLenis();
    }

    destroy() {
        document.removeEventListener('keydown', this.eventHandler.escapeKey);
        this.closeButton.removeEventListener('click', this.eventHandler.closeButtonClick);
    }
}

export default ICoreMiniSearchWidget;